const searchBoxAdapter = data => {
	const list = [
		{
			title: "Hotels",
			items: data?.map(hotel => ({
				label: hotel?.HotelName,
				value: hotel?.RegionName,
				destination: hotel?.DestinationName,
			})),
		},
	];

	return list;
};

export default searchBoxAdapter;
